import { RemoteDistributions } from '../../../data/usecases/distributions/distributions'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory'

export const makeRemoteDistributions = ():any => new RemoteDistributions('/configuracaodistribuidor', makeAxiosHttpClient())

export const makeRemoteDistributionItem = (id:number):any => new RemoteDistributions(`/configuracaodistribuidor/${id}`, makeAxiosHttpClient())

export const makeRemoteDistributionList = ():any => new RemoteDistributions('/distribuidor', makeAxiosHttpClient())
